import { render, staticRenderFns } from "./DC_ZH_3F.vue?vue&type=template&id=587dd355&scoped=true"
import script from "./DC_ZH_3F.vue?vue&type=script&lang=js"
export * from "./DC_ZH_3F.vue?vue&type=script&lang=js"
import style0 from "./DC_ZH_3F.vue?vue&type=style&index=0&id=587dd355&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587dd355",
  null
  
)

export default component.exports